import { useQuery } from '@tanstack/react-query'
import { transcriptionAIKeys } from './transcriptionAI.keys'
import { UserFriendlyError } from '../../../model/Error'
import { checkTranscription } from '../../../data/transcriptionAI/checkTranscription'

export const useCheckTranscription = () => {
  const queryKey = transcriptionAIKeys.check

  return useQuery({
    queryKey,
    queryFn: async () => {
      const { data, ok } = await checkTranscription()

      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          `Impossible de vérifier si une transcription est en cours`,
          `Une erreur technique s'est produite`,
        )
      }

      return data
    },
    gcTime: 0,
    staleTime: 0,
  })
}
